/* eslint-disable max-len */
import React from 'react'
import GrayButton from './GrayButton'
import BlueButton from './BlueButton'

interface Props {
  buttonVariant: 'small' | 'xlarge'
  buttonType: 'gray' | 'blue'
  children: React.ReactNode
  withArrow?: boolean
  className?: string
  onClick?: () => void
}

const NewButton = (props: Props): JSX.Element => {
  if (props.buttonType === 'gray') {
    return (
      <GrayButton className={props.className} variant={props.buttonVariant} onClick={props.onClick}>
        {props.children}
        {props.withArrow === true && (
          <span>
            <svg
              width={props.buttonVariant === 'xlarge' ? '20' : '13'}
              height={props.buttonVariant === 'xlarge' ? '18' : '12'}
              viewBox="0 0 13 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.10604 0.981044C7.2891 0.797985 7.5859 0.797985 7.76896 0.981044L12.4565 5.66854C12.5444 5.75645 12.5938 5.87568 12.5938 6C12.5938 6.12432 12.5444 6.24355 12.4565 6.33146L7.76896 11.019C7.5859 11.202 7.2891 11.202 7.10604 11.019C6.92298 10.8359 6.92298 10.5391 7.10604 10.356L10.9933 6.46875H0.875C0.616117 6.46875 0.40625 6.25888 0.40625 6C0.40625 5.74112 0.616117 5.53125 0.875 5.53125H10.9933L7.10604 1.64396C6.92299 1.4609 6.92299 1.1641 7.10604 0.981044Z"
                fill="#1D293D"
              />
            </svg>
          </span>
        )}
      </GrayButton>
    )
  }

  if (props.buttonType === 'blue') {
    return (
      <BlueButton className={props.className} variant={props.buttonVariant} onClick={props.onClick}>
        {props.children}
        {props.withArrow === true && (
          <span>
            <svg
              width={props.buttonVariant === 'xlarge' ? '20' : '13'}
              height={props.buttonVariant === 'xlarge' ? '18' : '12'}
              viewBox="0 0 13 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.10604 0.981044C7.2891 0.797985 7.5859 0.797985 7.76896 0.981044L12.4565 5.66854C12.5444 5.75645 12.5938 5.87568 12.5938 6C12.5938 6.12432 12.5444 6.24355 12.4565 6.33146L7.76896 11.019C7.5859 11.202 7.2891 11.202 7.10604 11.019C6.92298 10.8359 6.92298 10.5391 7.10604 10.356L10.9933 6.46875H0.875C0.616117 6.46875 0.40625 6.25888 0.40625 6C0.40625 5.74112 0.616117 5.53125 0.875 5.53125H10.9933L7.10604 1.64396C6.92299 1.4609 6.92299 1.1641 7.10604 0.981044Z"
                fill="#F8FAFC"
              />
            </svg>
          </span>
        )}
      </BlueButton>
    )
  }

  return <div>Button</div>
}

export default NewButton
